import React, { useId } from "react";

export const RiseAltLogo = ({
  height = 24,
  width = 50,
  className,
}: {
  height?: number | string;
  width?: number | string;
  className?: string;
}) => {
  const gradientId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid={"rise-alt-logo"}
    >
      <path
        d="M45.2131 0C48.2484 -8.7946e-07 50.5167 2.77849 49.8977 5.73766L46.9035 20.0497C46.4427 22.2519 44.4983 23.8328 42.2395 23.8424L4.80777 24C1.75205 24.0128 -0.533163 21.2092 0.108546 18.2341L3.23062 3.76449C3.70443 1.56862 5.65396 3.14156e-05 7.90934 0H45.2131ZM29.6057 4.88382C26.9833 4.88382 24.6672 6.59921 24.6672 9.26778C24.6673 10.8878 25.5095 12.2413 27.3469 12.9846L28.9357 13.6323C29.7011 13.9563 29.9113 14.395 29.9113 14.9286C29.9113 15.7863 29.2417 16.3386 28.0744 16.3387C26.4091 16.3006 25.7199 15.1955 25.7199 14.0709C25.7199 13.8993 25.7388 13.7276 25.758 13.6323L22.9826 14.1088C22.9635 14.2231 22.9445 14.3757 22.9445 14.6233C22.9445 16.3768 24.284 18.9507 28.131 18.9508C31.2701 18.9508 33.0509 16.8158 33.051 14.7001C33.051 13.0418 32.2082 11.7838 30.1027 10.8879L28.6672 10.2772C28.1314 10.0485 27.7101 9.68642 27.7101 9.00035C27.7103 8.25712 28.3611 7.49511 29.4709 7.49494C31.308 7.49494 31.4806 8.90466 31.4807 9.28626L34.2951 8.82919C34.2951 7.43777 33.3378 4.88401 29.6057 4.88382ZM8.94742 5.15028L6.07633 18.6649H9.09977L10.172 13.6323H11.5881L13.3302 18.6649H16.5265L14.4982 13.1752C16.4122 12.5271 17.7902 10.9062 17.7902 8.65706C17.79 6.65592 16.4311 5.15039 13.8283 5.15028H8.94742ZM20.5226 5.15028L17.6515 18.6649H20.6955L23.5851 5.15028H20.5226ZM36.5529 5.15028L33.6818 18.6649H42.2756L42.8879 15.8058H37.299L37.8547 13.2132H42.9074L43.4621 10.5641H38.4094L38.9641 7.98994H44.5344L45.1467 5.15028H36.5529ZM13.0812 7.74293C14.1913 7.74293 14.67 8.27616 14.6701 9.09565C14.6701 10.2202 13.828 11.0406 12.4308 11.0406H10.7082L11.4162 7.74293H13.0812Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="-2.06498"
          y1="12.4293"
          x2="45.894"
          y2="-16.8376"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6700" />
          <stop offset="0.213542" stopColor="#FF4430" />
          <stop offset="0.385417" stopColor="#F7184A" />
          <stop offset="0.53125" stopColor="#E60062" />
          <stop offset="0.713542" stopColor="#CE0077" />
          <stop offset="0.859375" stopColor="#AD0088" />
          <stop offset="1" stopColor="#851694" />
        </linearGradient>
      </defs>
    </svg>
  );
};
